import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { MAX_DURATION_AUDIO_SEC } from '../../../modules/player/player-module/split/utils'

interface Props {
  isPro?: boolean
  isHifi?: boolean
  duration?: number | null
}

interface UseModalInformation {
  show?: boolean
  title: string
  description?: string
  image?: string
  imageHighlight?: string
  showBackground?: boolean
  confirmIcon?: string
  confirmLabel: string
  onConfirm(): void
  onDismiss(): void
  shouldCloseOnOverlayClick?: boolean
}

export const useModalInformation = ({
  isPro,
  isHifi,
  duration
}: Props): UseModalInformation => {
  const { i18n } = useLingui()

  const [showed, setShowed] = useState(true) // 180 min songs: disabled for now
  const [showModal, setShowModal] = useState(false)
  const onDismiss = useCallback(() => setShowModal(false), [])

  useEffect(() => {
    if (
      isPro &&
      isHifi &&
      !showed &&
      duration &&
      duration > MAX_DURATION_AUDIO_SEC
    ) {
      setShowModal(true)
      setShowed(true)
    }
  }, [duration, isPro, isHifi, showed])

  const dataModal = useMemo(
    () => ({
      showBackground: true,
      image: 'paywall/warning',
      title: i18n._(t`banner_length_exceed_title`),
      description: i18n._(t`banner_length_exceed_description`),
      confirmLabel: t`Got it`,
      onConfirm: onDismiss,
      onDismiss,
      onClose: onDismiss
    }),
    [i18n, onDismiss]
  )

  return {
    show: showModal,
    ...dataModal
  }
}
